import React from "react";
import { DollarSign, Shield, Users, Clock } from "lucide-react";
export const Overview = () => {
  const benefits = [{
    icon: <DollarSign className="h-6 w-6" data-id="element-78" />,
    title: "Easy Income",
    description: "Starting at 150€ monthly, with potential for more based on engagement."
  }, {
    icon: <Shield className="h-6 w-6" data-id="element-79" />,
    title: "Privacy-Safe",
    description: "We protect your data and only use your LinkedIn for authorized posts and messages."
  }, {
    icon: <Users className="h-6 w-6" data-id="element-80" />,
    title: "Network Growth",
    description: "Connect with relevant professionals from your industry and exchange value through meaningful content."
  }, {
    icon: <Clock className="h-6 w-6" data-id="element-81" />,
    title: "Minimal Time Investment",
    description: "We do most of the legwork; you remain in control."
  }];
  return <section className="w-full bg-gray-50 py-16" data-id="element-82">
      <div className="max-w-4xl mx-auto px-4" data-id="element-83">
        <p className="text-lg text-gray-600 mb-12" data-id="element-84">
          Here's the deal: Companies want real people talking about their
          products, not just ads. You choose brands you actually like, and we'll
          help you share them with your network. Meanwhile, your LinkedIn grows
          on autopilot with genuine connections from your industry. Sweet,
          right?
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-85">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start space-x-4 bg-white p-6 rounded-lg shadow-sm" data-id="element-86">
              <div className="text-emerald-600" data-id="element-87">{benefit.icon}</div>
              <div data-id="element-88">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-89">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-90">{benefit.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};